const EditIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.5 3.00016H3.5C2.96957 3.00016 2.46086 3.21088 2.08579 3.58595C1.71071 3.96102 1.5 4.46973 1.5 5.00016V16.0002C1.5 16.5306 1.71071 17.0393 2.08579 17.4144C2.46086 17.7894 2.96957 18.0002 3.5 18.0002H14.5C15.0304 18.0002 15.5391 17.7894 15.9142 17.4144C16.2893 17.0393 16.5 16.5306 16.5 16.0002V11.0002M15.086 1.58616C15.2705 1.39514 15.4912 1.24278 15.7352 1.13796C15.9792 1.03314 16.2416 0.977969 16.5072 0.975661C16.7728 0.973354 17.0361 1.02396 17.2819 1.12452C17.5277 1.22508 17.751 1.37359 17.9388 1.56137C18.1266 1.74916 18.2751 1.97246 18.3756 2.21825C18.4762 2.46405 18.5268 2.72741 18.5245 2.99296C18.5222 3.25852 18.467 3.52096 18.3622 3.76497C18.2574 4.00898 18.105 4.22967 17.914 4.41416L9.328 13.0002H6.5V10.1722L15.086 1.58616Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
